import React from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners'


import NFButton from '../../primitives/NFButton';
import msgs from '../../../config/messages';
import formConfig from './formConfig';
import './ToolingForm.scss';

export default class PdmiForm extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    searchReset: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
      niin: PropTypes.string,
      partNum: PropTypes.string,
      description: PropTypes.string,
      wsdc: PropTypes.string,
      wsName: PropTypes.string,
      searchCage: PropTypes.string,
      solicitation: PropTypes.string,
    }).isRequired,
    searchTypeIsP: PropTypes.bool.isRequired,
    onChangeField: PropTypes.func.isRequired,
    disableSearchButtons: PropTypes.bool.isRequired,
    submitLabel: PropTypes.string,
    isCoreOnly: PropTypes.bool,
  };

  static defaultProps = {
    submitLabel: undefined,
    isCoreOnly: false,
  };

  render() {
    const { onSubmit, searchReset, initialValues, onChangeField, searchTypeIsP, disableSearchButtons, submitLabel, isCoreOnly } = this.props;
    // console.log(initialValues);
    return (
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        onChangeField={onChangeField}
        searchTypeIsP={searchTypeIsP}
        render={({ handleSubmit }) => (
          <form className="nf-tooling-search-form" onSubmit={handleSubmit}>
            <div>
              {formConfig.map(fieldConfig => (
                <div className="nf-tooling-search-form___inputFields">
                  <Field
                    key={fieldConfig.name}
                    disabled={(searchTypeIsP && fieldConfig.hideInProcSearch)}
                    isCoreOnly={isCoreOnly}
                    // disabled={
                    //   window.location.search &&
                    //   !window.location.search.includes(fieldConfig.name)
                    // }
                    {...fieldConfig}
                  />
                </div>
              ))}
              {formConfig.map(fieldConfig => (
                <OnChange key={fieldConfig.name} name={fieldConfig.name}>
                  {(value) => {
                    onChangeField(value, fieldConfig.name)
                  }}
                </OnChange>
              ))}
              <Row>
                <Col className="text-center">
                  <NFButton
                    className="nf-button--form nf-button--orange"
                    type="submit"
                    disabled={Object.keys(initialValues).length === 0 || disableSearchButtons}
                  >
                    {submitLabel || msgs.Form.submitButton}
                  </NFButton>
                  <NFButton
                    className="nf-button nf-button--gray-border btn btn-secondary"
                    onClick={searchReset}
                    style={{ marginLeft: '30px' }}

                    disabled={disableSearchButtons}
                  >
                    Reset
                  </NFButton>
                </Col>
              </Row>
            </div>
          </form>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/ToolingSearch/ToolingSearchForm.jsx